const UNAVAILABLE_METRIC = '—';

export function formatMetric(value: number | null, locale: string): string {
  if (value === null || !Number.isFinite(value)) return UNAVAILABLE_METRIC;

  try {
    return new Intl.NumberFormat(locale).format(value);
  } catch {
    return new Intl.NumberFormat('en-US').format(value);
  }
}

/** Growth values: "+1,200", "-40", "0", or "—" when unknown. */
export function formatSignedMetric(value: number | null, locale: string): string {
  if (value === null || !Number.isFinite(value)) return UNAVAILABLE_METRIC;
  return value > 0 ? `+${formatMetric(value, locale)}` : formatMetric(value, locale);
}
